import React from 'react';
import { ServicePageTemplate } from '../components/blocks/ServicePageTemplate';
import { getService } from '../data/services';

/**
 * PAGE: /start-your-journey/meditation-between-worlds
 * WORDPRESS: `service` CPT record, rendered by single-service.php
 *
 * All content lives in data/services.ts. This file only selects the record.
 */
export function MeditationBetweenWorlds() {
  return <ServicePageTemplate service={getService('meditation-between-worlds')} data-id="element-571" data-mp="srzhj80614ez" />;
}